import Avatar from '@eversports/klimt-primitives/legacy/Avatar'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { VenueType } from '../../../App.types'
import { Localized } from '../../../localization/react'
import { Trainer } from '../ActivityDetails.types'
import { getTrainerTranslationKey } from '../helpers/get-trainer-translation-key'

interface Props {
  trainer?: Trainer
  venueType: VenueType | null
}

const TrainerInfo = ({ trainer, venueType }: Props) => {
  // If there's descriptive info, hide this component, because we'll show one in the Overview section with more content.
  const hideTrainerWithContent = !trainer || (trainer.description && trainer.education)

  if (hideTrainerWithContent) {
    return null
  }

  const trainerLabelKey = getTrainerTranslationKey(venueType)

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Avatar
        src={trainer.image?.xSmall}
        alt={trainer.nickname}
        sx={{
          borderRadius: '80px',
          border: '1px solid',
          borderColor: 'mediumgray',
          width: '32px',
          height: '32px',
        }}
      />
      <Stack>
        <Text color="midnight">{trainer.nickname}</Text>
        <Text>
          <Localized id={trainerLabelKey} params={{ trainerCount: 1 }} />
        </Text>
      </Stack>
    </Stack>
  )
}

export default TrainerInfo
